"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnableReservationsResult = void 0;
var EnableReservationsResult;
(function (EnableReservationsResult) {
    EnableReservationsResult["successful"] = "successful";
    EnableReservationsResult["tokenInvalid"] = "tokenInvalid";
    EnableReservationsResult["hoursRequired"] = "hoursRequired";
})(EnableReservationsResult || (exports.EnableReservationsResult = EnableReservationsResult = {}));
//# sourceMappingURL=EnableReservationsResult.js.map